import { render, staticRenderFns } from "./GamesTab.vue?vue&type=template&id=fd584e96&scoped=true&"
import script from "./GamesTab.vue?vue&type=script&lang=js&"
export * from "./GamesTab.vue?vue&type=script&lang=js&"
import style0 from "./GamesTab.vue?vue&type=style&index=0&id=fd584e96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd584e96",
  null
  
)

export default component.exports